function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M17 15.76a1 1 0 01-2 0V4.33l-3.763 4.106a1 1 0 01-1.474-1.352l5.131-5.598a1.5 1.5 0 012.212 0l5.131 5.598a1 1 0 01-1.474 1.352L17 4.33v11.43z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 14a1 1 0 011-1h3.5a1 1 0 100-2H7a3 3 0 00-3 3v13a3 3 0 003 3h18a3 3 0 003-3V14a3 3 0 00-3-3h-3.5a1 1 0 100 2H25a1 1 0 011 1v13a1 1 0 01-1 1H7a1 1 0 01-1-1V14z",
  fill: "currentColor"
})));